


















 
import { defineComponent , useRouter, useContext} from "@nuxtjs/composition-api";
import { useUiState } from "~/composables";
import { useUser } from '~/modules/customer/composables/useUser';
export default defineComponent({
  components: {},
  setup() {
    const router = useRouter();
    const { app } = useContext();
    const { isAuthenticated } = useUser();
    const { toggleLoginModal } = useUiState();

    const handleAccountClick = async () => {
      if (isAuthenticated.value) {
        await router.push(app.localeRoute({ name: 'customer-my-profile' }));
      } else {
        toggleLoginModal();
      }
    };
    const handleAccountMobileClick = async () => {
      if (isAuthenticated.value) {
        await router.push(app.localeRoute({ name: 'customer-my-account' }));
      } else {
        toggleLoginModal();
      }
    };

    return {
      toggleLoginModal,handleAccountClick,handleAccountMobileClick
    };
  },
});
